<section class="realse-block">
    <div *ngIf="!showLoader">
        <img *ngIf="step == 'active'" src="/assets/images/unfreeze-direct-debit/lock.svg" alt="" class="lock" />
        <img
            *ngIf="step == 'success'"
            src="/assets/images/unfreeze-direct-debit/best-offer.svg"
            alt=""
            class="offer-icon"
        />
        <img
            *ngIf="step == 'error'"
            src="/assets/images/unfreeze-direct-debit/ice-cream.svg"
            alt=""
            class="ice-cream"
        />
        <h1>{{ title }}</h1>
        <div class="info-text">
            <div *ngIf="step == 'success'">
                {{ subTitle }}
            </div>
            {{ infoText }}
        </div>
        <div class="button-wrapper">
            <a class="brand-button aqua-button" (click)="next()"
                ><span>{{ btnText }}</span></a
            >
            <a *ngIf="showLink" class="link" (click)="nextLink()">{{ linkText }}</a>
        </div>
    </div>
    <max-loader *ngIf="showLoader" [justLoaderIcon]="true"></max-loader>
</section>
